import Navaid from "navaid";
import {get}	 from "svelte/store";
import Home from "./routes/home.svelte";

import Discover from "./routes/discover.svelte";
import Import from "./routes/import/import.svelte";
import Summary from "./routes/import/components/summary.svelte";
import Logs from "./routes/import/logs.svelte";

//import MatchUsers from "./routes/import/matchusers_old.svelte";

import StaffLogs from "./routes/import/stafflogs.svelte"
import ContactLogs from "./routes/import/contactlogs.svelte"
import AttendanceLogs from "./routes/import/attendancelogs.svelte"
import ClassLogs from "./routes/import/classlogs.svelte"
import PupilLogs from "./routes/import/pupillogs.svelte"
import StaffPendingRequests from "./routes/import/staffpendingrequests.svelte"
import Export from "./routes/export/export.svelte";
import ExportLogs from "./routes/export/exportlogs.svelte";
import ExportLogDetails from "./routes/export/exportlogdetails.svelte";
import ExportNewUsers from "./routes/export/createdUsers.svelte";
import DetailedLogs from "./routes/export/detailedLogs.svelte";
import SyncLogs from "./routes/export/syncLogs.svelte";
import Classrooms from "./routes/export/classrooms.svelte";

import Reports from "./routes/reports.svelte";

import Users from "./routes/users.svelte";
import ExportSummary from "./routes/export/sync-summary.svelte";
import Class from "./routes/class.svelte";

import Help from "./routes/help.svelte";
import Permissions from "./routes/permissions/permissions.svelte";
import Register from "./routes/register.svelte";
import Error from "./routes/error.svelte";
import Invite from "./routes/invite.svelte";
import MultiSyncPage from "./routes/multisyncPage.svelte";

import Subscriptions from "./routes/subscriptions.svelte";
import SubscriptionsNew from "./routes/subscriptions/new.svelte";
import SubscriptionsEdit from "./routes/subscriptions/edit.svelte";

import Error404 from "./routes/error404.svelte";

import TestExport from "./routes/export/testexport.svelte";
import TestExportDetails from "./routes/export/testexportdetails.svelte";

import { writable } from 'svelte/store';
import {AuthUser} from './store.js';
export const route = writable({ });
export const params = writable({ });

let installedApps=[];
AuthUser.set(u);
const isAtomwideUser = ()=>{
	if(get(AuthUser) == null)
	return false;
	return (get(AuthUser).schoolId == 18854) ;
	//get(AuthUser).universalId.endsWith('.000');
}
if( get(AuthUser))
	installedApps = get(AuthUser).installedAppId;
	let on404 = uri => route.set(Error404);

const router = Navaid("/app/", on404)
		.on("/", (p) => {			
			if(isAtomwideUser())
			router.route('/subscriptions',true)
			else
			route.set( Home);
			params.set( p);
		})
		.on("/discover", (p) => {
			route.set(Discover);
			params.set( p);
		})
		.on("/users", (p) => {
			route.set(Users);
			params.set( p);
		})
		.on("/class", (p) => {
			route.set(Class);
			params.set( p);
		})
		.on("/help", (p) => {
			route.set(Help);
			params.set( p);
		})
		.on("/permissions", (p) => {
			if(!isAtomwideUser())
				route.set(Permissions);
			else
			 	router.route('/app',true)
			params.set(p)	
		})
		.on("/register", (p) => {
			route.set(Register);
			params.set(p);
		})
		.on("/error", (p) => {
			route.set(Error);
			params.set( p);
		})
		.on("/invite", (p) => {
			route.set(Invite);
			params.set(p);
		})
		.on("/invite/:Id", () => {
			if (!p){
				router.route('/invite',true);
				return;
			}			
			route.set(Invite);
			params.set(p);
		})

		.on("/subscriptions", (p) => {			
			if(isAtomwideUser())
				route.set(Subscriptions);
			else
				router.route('/app',true)	
			params.set(p);
		})
		
		.on("/subscriptions/new", (p) => {			
			if(isAtomwideUser())
				route.set(SubscriptionsNew);
			else
				router.route('/app',true)
			params.set(p);
		})
		
		.on("/subscriptions/:customersID/:showPermissions?", (p) => {
			if (!p){
				router.route(`/subscriptions`,true);
				return;
			}			
			if(isAtomwideUser())
				route.set(SubscriptionsEdit);
			else
				router.route('/app',true)
			params.set( p);

		})

		.on("/reports", (p) => {			
			if(isAtomwideUser())
				route.set(Reports);
			else
				router.route('/app',true)
			params.set(p);
		})

		.on("/multisyncPage/:providerId", (p) => {			
			route.set(MultiSyncPage);
			params.set(p);
		})
		
		.on("/import/logs", (p) => {
			route.set(Logs);
			params.set( p);
		})
		.on("/import/logs/staff", (p) => {
			route.set(StaffLogs);
			params.set( p);
		})
		.on("/import/logs/pupil", (p) => {
			route.set(PupilLogs);
			params.set( p);
		})
		.on("/import/classlogs", (p) => {
			route.set(ClassLogs);
			params.set( p);
		})
		.on("/import/contactlogs", (p) => {
			route.set(ContactLogs);
			params.set( p);
		})
		.on("/import/attendancelogs", (p) => {
			route.set(AttendanceLogs);
			params.set( p);
		})
		.on("/import/logs/staffpendingrequests/:guid?/:actionType?", (p) => {
			route.set(StaffPendingRequests);
			params.set( p);
		})
	
		// .on("/import/matchusers", (p) => {
		// 	route.set(MatchUsers);
		// //	params.set( p);
		// })
		.on("/import/:step?", (p) => {
			if (!p.step){
				router.route(`/import/step1`,true);
				return;
			}
			route.set(Import);
			params.set( p);

		
		})
		// .on("/export/summary", (p) => {
		// 	route.set(ExportSummary);
		// 	params.set( p);
		// })
		.on("/export/:providerId/testexport", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(TestExport);
			params.set( p);
		})	
		.on("/export/:providerId/testexport/:role?", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(TestExportDetails);
			params.set( p);
		})
		.on("/export/:providerId/newUsers", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(ExportNewUsers);
			params.set(p);
		})	
		.on("/export/:providerId/syncLogs", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(SyncLogs);
			params.set(p);
		})	
		.on("/export/:providerId/detailedLogs", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(DetailedLogs);
			params.set(p);
		})	
		.on("/export/:providerId/logs", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(ExportLogs);
			params.set( p);
		})	
		.on("/export/:providerId/logs/:role?", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(ExportLogDetails);
			params.set( p);
		})
		.on("/export/:providerId/classrooms", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			route.set(Classrooms);
			params.set( p);
		})
		.on("/export/:providerId/:step?/:error?", (p) => {
			if(!installedApps.includes(p.providerId))
			{
				router.route("/",true);
				return;
			}
			if (!p.step){
				router.route(`/export/${p.providerId}/step1`,true);
				return;
			}

			route.set(Export);
			params.set( p);

		
		})
		
		
export const resolveExportUrl = (providerId, relativePath) => {
    return `/app/export/${providerId}${relativePath}`;
} 

export default  router